import {
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
    useTheme,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Observer } from "mobx-react";
import React from "react";
import { IAcxTableRow } from "./AcxTable";
import AcxTableViewModel from "./AcxTableViewModel";

export type OrderDirectionType = "asc" | "desc";

interface Props {
    viewModel: AcxTableViewModel;
    onSelectAllClick?: (selected: boolean) => void;
    onRequestSort?: (
        event: React.MouseEvent<unknown>,
        property: keyof IAcxTableRow,
    ) => void;
}

function AcxTableHeader(props: Props) {
    const theme = useTheme();
    const getCellSx = () =>
        props.viewModel.enableDense
            ? {
                  paddingLeft: 1,
                  paddingRight: 1,
                  paddingTop: 1,
                  paddingBottom: 1,
                  fontSize: "13px",
              }
            : {
                  paddingLeft: 2,
                  paddingRight: 2,
                  paddingTop: 2,
                  paddingBottom: 2,
                  fontSize: "13px",
              };
    const backgroundSx = {
        backgroundColor: theme.palette.primary.main + " !important",
        position: "sticky",
        top: 0,
        zIndex: 1,
    };
    const fontSx = {
        color: theme.palette.white.main,
    };

    const onSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.viewModel.onSelectAllClick(event.currentTarget.checked);
    };
    const createSortHandler =
        (property: keyof IAcxTableRow) =>
        (event: React.MouseEvent<unknown>) => {
            props.viewModel.tableSort(property);
        };

    return (
        <Observer>
            {() =>
                props.viewModel.colCells?.length > 0 ? (
                    <TableHead sx={backgroundSx}>
                        <TableRow>
                            {props.viewModel.enableCheck && (
                                <TableCell
                                    sx={{ ...backgroundSx, ...fontSx }}
                                    padding="checkbox"
                                >
                                    <Checkbox
                                        checked={props.viewModel.selectAllRows}
                                        onChange={onSelectAllClick}
                                        color="primary"
                                        style={{
                                            color: theme.palette.white.main,
                                        }}
                                    />
                                </TableCell>
                            )}
                            {props.viewModel.colCells?.map((cell, l) => (
                                <TableCell
                                    key={"table_header_" + l}
                                    sx={{
                                        ...backgroundSx,
                                        ...fontSx,
                                        ...getCellSx(),
                                    }}
                                    align={cell.numeric ? "right" : "left"}
                                    padding={
                                        cell.disablePadding ? "none" : "normal"
                                    }
                                >
                                    <TableSortLabel
                                        active={
                                            props.viewModel.orderByField ===
                                            cell.id
                                        }
                                        direction={
                                            props.viewModel.orderByField ===
                                            cell.id
                                                ? props.viewModel.orderDir
                                                : "asc"
                                        }
                                        onClick={createSortHandler(cell.id)}
                                        hideSortIcon={
                                            !props.viewModel.enableSort
                                        }
                                    >
                                        {cell.label}
                                        {props.viewModel.orderByField ===
                                        cell.id ? (
                                            <span
                                                style={{
                                                    border: 0,
                                                    clip: "rect(0 0 0 0)",
                                                    height: 1,
                                                    margin: -1,
                                                    overflow: "hidden",
                                                    padding: 0,
                                                    position: "absolute",
                                                    top: 20,
                                                    width: 1,
                                                }}
                                            >
                                                {props.viewModel.orderDir ===
                                                "desc"
                                                    ? "sorted descending"
                                                    : "sorted ascending"}
                                            </span>
                                        ) : null}
                                    </TableSortLabel>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                ) : (
                    <></>
                )
            }
        </Observer>
    );
}

export default AcxTableHeader;
